/* Фирмена покана: избор на визия и изтриваема лента. Само за фирмения шаблон, без сватбени файлове. */
(function () {
  var DESIGNS = [
    { id: 'gold', bg: 'Златен пропуск', en: 'Golden pass' },
    { id: 'boarding', bg: 'Бордна карта', en: 'Boarding pass' },
    { id: 'vip', bg: 'VIP пропуск', en: 'VIP pass' },
    { id: 'festive', bg: 'Празничен билет', en: 'Celebration ticket' },
    { id: 'elegant', bg: 'Елегантна покана', en: 'Elegant invitation' }
  ];
  var TEXT = {
    bg: { choose: 'Изберете визия на билета · пример', hint: 'Изтрийте златната лента с пръст или натиснете бутона.', strip: 'ИЗТРИЙТЕ ТУК', reveal: 'Вие сте в списъка с гости', open: 'Отворете поканата', aria: 'Изтриваема лента. Можете да отворите поканата и с бутона под билета.' },
    en: { choose: 'Choose a ticket design · preview', hint: 'Scratch the golden strip with your finger or use the button.', strip: 'SCRATCH HERE', reveal: 'You are on the guest list', open: 'Open the invitation', aria: 'Scratch strip. You can also open the invitation with the button below the ticket.' }
  };
  var REVEAL_AT = 0.5;

  var ticket = document.getElementById('ticket');
  var openButton = document.getElementById('open');
  if (!ticket || !openButton) return;
  var main = ticket.querySelector('.ticket-main');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function lang() { return document.documentElement.lang === 'en' ? 'en' : 'bg'; }
  function t(key) { return TEXT[lang()][key]; }

  function readDesign() {
    var fromEditor = document.documentElement.dataset.corporateDesign;
    return DESIGNS.some(function (d) { return d.id === fromEditor; }) ? fromEditor : 'gold';
  }
  var current = readDesign();

  // Изтриваема лента
  var scratch = document.createElement('div');
  scratch.className = 'scratch';
  var reveal = document.createElement('div');
  reveal.className = 'scratch-reveal';
  var revealStar = document.createElement('span');
  revealStar.setAttribute('aria-hidden', 'true');
  revealStar.textContent = '✦';
  var revealText = document.createElement('strong');
  revealText.style.fontWeight = '400';
  reveal.appendChild(revealStar);
  reveal.appendChild(revealText);
  var canvas = document.createElement('canvas');
  canvas.setAttribute('role', 'img');
  scratch.appendChild(reveal);
  scratch.appendChild(canvas);
  var hint = document.createElement('p');
  hint.className = 'scratch-hint';
  main.appendChild(scratch);
  main.appendChild(hint);

  var ctx = canvas.getContext('2d');
  var finished = false;
  var drawing = false;
  var last = null;
  var moves = 0;

  function cssVar(name) { return getComputedStyle(ticket).getPropertyValue(name).trim(); }
  function mixHex(hex, other, share) {
    if (!/^#[0-9a-f]{6}$/i.test(hex)) return '';
    var out = '#';
    for (var i = 1; i < 7; i += 2) {
      var a = parseInt(hex.slice(i, i + 2), 16);
      var b = parseInt(other.slice(i, i + 2), 16);
      out += ('0' + Math.round(a * (1 - share) + b * share).toString(16)).slice(-2);
    }
    return out;
  }
  function stripColors() {
    var accent = (document.documentElement.dataset.corporateAccent || '').toLowerCase();
    if (ticket.classList.contains('design-gold') && /^#[0-9a-f]{6}$/.test(accent)) {
      return [mixHex(accent, '#000000', 0.18), mixHex(accent, '#ffffff', 0.45), mixHex(accent, '#000000', 0.32)];
    }
    return [cssVar('--scratch-a') || '#b8924a', cssVar('--scratch-b') || '#f3dc9b', cssVar('--scratch-c') || '#9c7738'];
  }

  function paint() {
    if (finished) return;
    var ratio = window.devicePixelRatio || 1;
    var box = scratch.getBoundingClientRect();
    if (!box.width) return;
    canvas.width = Math.round(box.width * ratio);
    canvas.height = Math.round(box.height * ratio);
    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
    ctx.globalCompositeOperation = 'source-over';
    var grad = ctx.createLinearGradient(0, 0, box.width, box.height);
    var stops = stripColors();
    grad.addColorStop(0, stops[0]);
    grad.addColorStop(0.5, stops[1]);
    grad.addColorStop(1, stops[2]);
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, box.width, box.height);
    ctx.fillStyle = 'rgba(255,255,255,.18)';
    for (var x = -box.height; x < box.width; x += 14) {
      ctx.beginPath();
      ctx.moveTo(x, box.height);
      ctx.lineTo(x + box.height, 0);
      ctx.lineTo(x + box.height + 4, 0);
      ctx.lineTo(x + 4, box.height);
      ctx.fill();
    }
    ctx.fillStyle = 'rgba(40,30,15,.75)';
    ctx.font = '600 14px Arial, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('✦  ' + t('strip') + '  ✦', box.width / 2, box.height / 2);
  }

  function point(e) {
    var box = canvas.getBoundingClientRect();
    return { x: e.clientX - box.left, y: e.clientY - box.top };
  }

  function erase(from, to) {
    ctx.globalCompositeOperation = 'destination-out';
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.lineWidth = 34;
    ctx.beginPath();
    ctx.moveTo(from.x, from.y);
    ctx.lineTo(to.x, to.y);
    ctx.stroke();
  }

  function clearedShare() {
    var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    var clear = 0;
    var total = 0;
    for (var i = 3; i < data.length; i += 64) {
      total++;
      if (data[i] < 40) clear++;
    }
    return total ? clear / total : 0;
  }

  function finish() {
    if (finished) return;
    finished = true;
    scratch.classList.add('done');
    if (navigator.vibrate) { try { navigator.vibrate(30); } catch (e) {} }
    setTimeout(function () { openButton.click(); }, reducedMotion ? 0 : 650);
  }

  canvas.addEventListener('pointerdown', function (e) {
    if (finished) return;
    drawing = true;
    last = point(e);
    erase(last, { x: last.x + 0.1, y: last.y });
    try { canvas.setPointerCapture(e.pointerId); } catch (err) {}
    e.preventDefault();
  });
  canvas.addEventListener('pointermove', function (e) {
    if (!drawing || finished) return;
    var p = point(e);
    erase(last, p);
    last = p;
    moves++;
    if (moves % 6 === 0 && clearedShare() >= REVEAL_AT) finish();
    e.preventDefault();
  });
  function stop() {
    if (!drawing) return;
    drawing = false;
    if (!finished && clearedShare() >= REVEAL_AT) finish();
  }
  canvas.addEventListener('pointerup', stop);
  canvas.addEventListener('pointercancel', stop);

  // Ако гостът отвори с бутона, лентата се изтрива сама.
  openButton.addEventListener('click', function () {
    if (!finished) { finished = true; scratch.classList.add('done'); }
  });

  // Избор на визия, само в демото и редактора на организатора
  var picker = document.createElement('div');
  picker.className = 'ticket-designs';
  var pickerLabel = document.createElement('p');
  var list = document.createElement('div');
  list.className = 'ticket-design-list';
  list.setAttribute('role', 'group');
  picker.appendChild(pickerLabel);
  picker.appendChild(list);
  DESIGNS.forEach(function (d) {
    var b = document.createElement('button');
    b.type = 'button';
    b.dataset.design = d.id;
    list.appendChild(b);
  });
  ticket.parentNode.insertBefore(picker, ticket.nextSibling);

  function applyDesign(id) {
    current = id;
    DESIGNS.forEach(function (d) { ticket.classList.toggle('design-' + d.id, d.id === id); });
    list.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.design === id)); });
    requestAnimationFrame(paint);
  }
  list.addEventListener('click', function (e) {
    var b = e.target.closest('[data-design]');
    if (!b) return;
    applyDesign(b.dataset.design);
    document.dispatchEvent(new CustomEvent('corporate-design', { detail: b.dataset.design }));
  });

  function applyLanguage() {
    pickerLabel.textContent = t('choose');
    list.setAttribute('aria-label', t('choose'));
    list.querySelectorAll('button').forEach(function (b) {
      var d = DESIGNS.filter(function (x) { return x.id === b.dataset.design; })[0];
      b.textContent = d[lang()];
    });
    hint.textContent = t('hint');
    revealText.textContent = t('reveal');
    canvas.setAttribute('aria-label', t('aria'));
    if (!openButton.hidden) openButton.textContent = t('open');
    paint();
  }

  new MutationObserver(applyLanguage).observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
  var resizeTimer;
  window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(paint, 150); });

  // Цветове на фирмата: фон и акцент, с проверка за четимост
  var M = globalThis.CORPORATE_MODEL;
  var COLOR_TEXT = {
    bg: { backgroundHelp: 'Голямата площ зад билета и в началото с отпечатването.', accentHelp: 'Светещата линия в началото, заглавията, линиите, бутоните и таблото „Време до партито“.', background: 'Фон', accent: 'Цвят на детайлите', custom: 'Свой цвят', darkNeeded: 'Леко затъмнихме цвета на фона, за да се чете текстът.', lightNeeded: 'Леко изсветлихме цвета на детайлите, за да се виждат на тъмния фон.', names: ['Нощно синьо', 'Графит', 'Бордо', 'Горско зелено', 'Петрол', 'Тъмна слива'] },
    en: { backgroundHelp: 'The large area behind the ticket and in the printing intro.', accentHelp: 'The glowing line in the intro, headings, lines, buttons and the countdown board.', background: 'Background', accent: 'Detail colour', custom: 'Custom colour', darkNeeded: 'We darkened the background slightly so the text stays readable.', lightNeeded: 'We lightened the detail colour slightly so it shows on the dark background.', names: ['Midnight blue', 'Graphite', 'Burgundy', 'Forest green', 'Petrol', 'Deep plum'] }
  };
  var colorRows = {};
  var colorNote = document.createElement('p');
  colorNote.className = 'fm-color-note';
  colorNote.setAttribute('role', 'status');
  function colorRow(kind, values) {
    var row = document.createElement('div');
    row.className = 'ticket-color-row';
    var label = document.createElement('span');
    var swatches = document.createElement('div');
    swatches.className = 'ticket-color-swatches';
    values.forEach(function (value) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ticket-color';
      b.style.setProperty('--swatch', value);
      b.dataset.colorKind = kind;
      b.dataset.colorValue = value;
      swatches.appendChild(b);
    });
    var customLabel = document.createElement('label');
    customLabel.className = 'ticket-color-custom';
    var customText = document.createElement('span');
    var input = document.createElement('input');
    input.type = 'color';
    input.dataset.colorKind = kind;
    customLabel.appendChild(input);
    customLabel.appendChild(customText);
    swatches.appendChild(customLabel);
    row.appendChild(label);
    row.appendChild(swatches);
    var help = document.createElement('small');
    help.className = 'ticket-color-help';
    row.appendChild(help);
    colorRows[kind] = { label: label, customText: customText, input: input, swatches: swatches, help: help };
    return row;
  }
  if (M && M.backgrounds) {
    picker.appendChild(colorRow('background', M.backgrounds));
    picker.appendChild(colorRow('accent', M.palettes));
    picker.appendChild(colorNote);
  }
  function currentColor(kind) {
    var root = document.documentElement.dataset;
    return kind === 'background' ? (root.corporateBackground || '#101e32') : (root.corporateAccent || '#c8a766');
  }
  function markColors() {
    Object.keys(colorRows).forEach(function (kind) {
      var value = currentColor(kind);
      var row = colorRows[kind];
      var matched = false;
      row.swatches.querySelectorAll('[data-color-value]').forEach(function (b) {
        var on = b.dataset.colorValue === value;
        if (on) matched = true;
        b.setAttribute('aria-pressed', String(on));
      });
      if (document.activeElement !== row.input) row.input.value = value;
      row.input.closest('label').classList.toggle('on', !matched);
    });
  }
  function fitColor(kind, value) {
    var valid = kind === 'background' ? M.validBackground : M.validAccent;
    if (valid(value)) return { value: value, adjusted: false };
    if (!/^#[0-9a-f]{6}$/.test(value)) return null;
    var target = kind === 'background' ? '#000000' : '#ffffff';
    for (var step = 1; step <= 40; step++) {
      var candidate = mixHex(value, target, step * 0.025);
      if (valid(candidate)) return { value: candidate, adjusted: true };
    }
    return null;
  }
  function chooseColor(kind, value, live) {
    value = String(value).toLowerCase();
    var fit = fitColor(kind, value);
    if (!fit) return;
    colorNote.textContent = fit.adjusted ? COLOR_TEXT[lang()][kind === 'background' ? 'darkNeeded' : 'lightNeeded'] : '';
    document.dispatchEvent(new CustomEvent(kind === 'background' ? 'corporate-background' : 'corporate-accent', { detail: fit.value }));
    if (!live) markColors();
    requestAnimationFrame(paint);
  }
  picker.addEventListener('click', function (e) {
    var b = e.target.closest('[data-color-value]');
    if (b) chooseColor(b.dataset.colorKind, b.dataset.colorValue);
  });
  picker.addEventListener('input', function (e) {
    if (e.target.matches('input[type=color]')) chooseColor(e.target.dataset.colorKind, e.target.value, true);
  });
  picker.addEventListener('change', function (e) {
    if (e.target.matches('input[type=color]')) chooseColor(e.target.dataset.colorKind, e.target.value);
  });
  function colorLanguage() {
    var text = COLOR_TEXT[lang()];
    Object.keys(colorRows).forEach(function (kind) {
      var row = colorRows[kind];
      row.label.textContent = text[kind];
      row.customText.textContent = text.custom;
      row.help.textContent = text[kind + 'Help'];
      row.input.setAttribute('aria-label', text[kind] + ': ' + text.custom);
      row.swatches.querySelectorAll('[data-color-value]').forEach(function (b, i) {
        b.setAttribute('aria-label', kind === 'background' ? text.names[i] : text.accent + ' ' + (i + 1));
      });
    });
    colorNote.textContent = '';
  }
  new MutationObserver(function () { markColors(); requestAnimationFrame(paint); }).observe(document.documentElement, { attributes: true, attributeFilter: ['data-corporate-accent', 'data-corporate-background'] });
  new MutationObserver(colorLanguage).observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
  colorLanguage();
  markColors();

  globalThis.CORPORATE_TICKETS = {
    setDesign: function (id) {
      if (id !== current && DESIGNS.some(function (d) { return d.id === id; })) applyDesign(id);
    }
  };
  applyDesign(current);
  applyLanguage();
})();
